<template>
  <b-row>
    <b-col cols="12">
      <job-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import JobContent from './JobContent.vue'

export default {
  components: {
    BRow,
    BCol,

    JobContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>